module.exports = {
      id: "lifestyle-usage",
      viewBox: "0 0 24.217 32.155",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#lifestyle",
      toString: function () {
        return this.url;
      }
    }